import { useState, useRef, TouchEvent, useEffect } from 'react';

interface PromoData {
  title_line1: string;
  subtitle_line1: string;
  subtitle_line2: string;
  subtitle_line3: string;
  subtitle_line4: string;
  post_image1: string;
  post_image2: string;
  post_image3: string;
  post_url1: string;
  post_url2: string;
  post_url3: string;
  instagram_url: string;
}

export default function PromoSection() {
  const [data, setData] = useState<PromoData>({
    title_line1: 'SEGUE-ME!',
    subtitle_line1: 'PROMETO',
    subtitle_line2: 'NÃO DEIXAR',
    subtitle_line3: 'MIGALHAS',
    subtitle_line4: 'NO TEU FEED.',
    post_image1: '/Imagens/pub1.png',
    post_image2: '/Imagens/pub2.png',
    post_image3: '/Imagens/pub3.png',
    post_url1: '',
    post_url2: '',
    post_url3: '',
    instagram_url: 'https://www.instagram.com/bolacha.mulata/'
  });

  const [currentPost, setCurrentPost] = useState(0);
  const [isTransitioning, setIsTransitioning] = useState(false);
  const [slideOffset, setSlideOffset] = useState(0);
  const touchStartX = useRef(0);
  const touchEndX = useRef(0);

  const titleSize = '3.5vw';
  const titleSizeMobile = '10vw';
  const subtitleSize = '2.31vw';
  // Mobile: 4.8vw * 1.2 = 5.76vw (20% increase)
  const subtitleSizeMobile = '5.76vw';

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      const response = await fetch('https://mulata.wortik.com/bolacha-mulata/api/promo.php');
      const result = await response.json();
      if (result) {
        setData(result);
      }
    } catch (err) {
      console.error('Error loading promo data:', err);
    }
  };

  const getImageSrc = (path: string) => {
    if (path.startsWith('http')) {
      return path;
    }
    return path;
  };

  const getPostUrl = (index: number) => {
    const urls = [data.post_url1, data.post_url2, data.post_url3];
    const specificUrl = urls[index];
    return specificUrl && specificUrl.trim() !== '' ? specificUrl : data.instagram_url;
  };

  const posts = [
    { image: data.post_image1, alt: 'Promoção 1', url: getPostUrl(0) },
    { image: data.post_image2, alt: 'Promoção 2', url: getPostUrl(1) },
    { image: data.post_image3, alt: 'Promoção 3', url: getPostUrl(2) }
  ];

  const nextSlide = () => {
    if (isTransitioning || posts.length === 0) return;
    setIsTransitioning(true);
    
    setSlideOffset(prev => prev - 480);
    
    setTimeout(() => {
      setCurrentPost((prev) => (prev + 1) % posts.length);
      setSlideOffset(0);
      setIsTransitioning(false);
    }, 400);
  };

  const prevSlide = () => {
    if (isTransitioning || posts.length === 0) return;
    setIsTransitioning(true);
    
    setSlideOffset(prev => prev + 480);
    
    setTimeout(() => {
      setCurrentPost((prev) => (prev - 1 + posts.length) % posts.length);
      setSlideOffset(0);
      setIsTransitioning(false);
    }, 400);
  };

  const getVisiblePosts = () => {
    if (posts.length === 0) return [];
    
    const visible = [];
    for (let i = -2; i <= 2; i++) {
      const index = (currentPost + i + posts.length) % posts.length;
      visible.push({
        post: posts[index],
        position: i,
        key: `post-${index}-${i}`
      });
    }
    return visible;
  };

  const handlePostTouchStart = (e: TouchEvent) => {
    touchStartX.current = e.touches[0].clientX;
  };

  const handlePostTouchMove = (e: TouchEvent) => {
    touchEndX.current = e.touches[0].clientX;
  };

  const handlePostTouchEnd = () => {
    const diff = touchStartX.current - touchEndX.current;
    if (Math.abs(diff) > 50) {
      if (diff > 0) {
        nextSlide();
      } else {
        prevSlide();
      }
    }
  };

  const visiblePosts = getVisiblePosts();

  return (
    <>
      {/* Instagram Section - Desktop */}
      <section 
        className="promo-section-desktop relative" 
        style={{ 
          backgroundImage: 'url(https://imgur.com/Jq1bLci.png)',
          backgroundSize: 'cover',
          backgroundPosition: 'center top',
          backgroundRepeat: 'no-repeat',
          width: '100%',
          paddingBottom: '57.29%',
          position: 'relative',
          height: 0,
          imageRendering: '-webkit-optimize-contrast',
          overflow: 'visible',
          zIndex: 5
        }}
      >
        <div 
          className="absolute left-0 right-0 flex flex-col items-center"
          style={{ 
            top: '65%',
            zIndex: 6
          }}
        >
          <h2 
            className="text-center prompt-black-font"
            style={{ 
              color: '#ffffff', 
              letterSpacing: '0.05em',
              fontSize: titleSize,
              marginBottom: '-1vw'
            }}
          >
            {data.title_line1}
          </h2>
          <p 
            className="text-center prompt-black-font"
            style={{ 
              color: '#ffffff', 
              letterSpacing: '0.05em',
              fontSize: subtitleSize,
              marginBottom: '4.17vw'
            }}
          >
            {data.subtitle_line1} {data.subtitle_line2} {data.subtitle_line3} {data.subtitle_line4}
          </p>

          <div 
            className="flex items-start justify-center"
            style={{
              gap: '1.08vw',
              maxWidth: '72.08vw'
            }}
          >
            {posts.map((post, index) => (
              <a
                key={index}
                href={post.url}
                target="_blank"
                rel="noopener noreferrer"
                className="instagram-post"
                style={{
                  width: '100%'
                }}
              >
                <div 
                  className="instagram-header-desktop"
                  style={{
                    padding: '0.83vw 1.04vw',
                    gap: '0.63vw'
                  }}
                >
                  <img 
                    src="https://i.imgur.com/OmUc2Y8.png" 
                    alt="Profile" 
                    className="instagram-avatar-desktop"
                    style={{
                      width: '2.29vw',
                      height: '2.29vw'
                    }}
                  />
                  <div 
                    className="instagram-username-desktop"
                    style={{
                      fontSize: '0.94vw',
                      gap: '0.31vw'
                    }}
                  >
                    <span className="font-semibold">bolacha.mulata</span>
                    <span className="instagram-follow">• Seguir</span>
                  </div>
                  <img 
                    src="https://i.imgur.com/Rk0c5ux.png" 
                    alt="Instagram" 
                    className="instagram-icon-desktop"
                    style={{
                      width: '1.67vw',
                      height: '1.67vw'
                    }}
                  />
                </div>
                <div 
                  className="instagram-image-container"
                  style={{
                    height: '27.6vw'
                  }}
                >
                  <img
                    src={getImageSrc(post.image)}
                    alt={post.alt}
                    className="instagram-image"
                    onError={(e) => {
                      e.currentTarget.src = `/Imagens/pub${index + 1}.png`;
                    }}
                  />
                </div>
              </a>
            ))}
          </div>
        </div>
      </section>

      {/* Instagram Section - Mobile - 600x1500px (250% ratio) */}
      <section 
        className="promo-section-mobile relative" 
        style={{ 
          backgroundImage: 'url(https://i.imgur.com/0QO6nQN.png)',
          backgroundSize: 'cover',
          backgroundPosition: 'center top',
          backgroundRepeat: 'no-repeat',
          width: '100%',
          paddingBottom: '250%',
          position: 'relative',
          height: 0,
          imageRendering: '-webkit-optimize-contrast',
          overflow: 'visible',
          zIndex: 5
        }}
      >
        {/* Content positioned higher */}
        <div 
          className="absolute left-0 right-0 w-full px-4 flex flex-col items-center"
          style={{ 
            top: '28%',
            zIndex: 6
          }}
        >
          {/* Title and Subtitle - Higher z-index to appear above posts */}
          <div style={{ position: 'relative', zIndex: 20 }}>
            <h2 
              className="text-center prompt-black-font"
              style={{ 
                color: '#ffffff', 
                letterSpacing: '0.05em',
                fontSize: titleSizeMobile,
                fontWeight: 900,
                marginBottom: '-1vw',
                lineHeight: '1.2'
              }}
            >
              {data.title_line1}
            </h2>
            <p 
              className="text-center prompt-black-font"
              style={{ 
                color: '#ffffff', 
                letterSpacing: '0.05em',
                fontSize: subtitleSizeMobile,
                fontWeight: 900,
                marginBottom: '62vw',
                lineHeight: '1.3'
              }}
            >
              {data.subtitle_line1}<br />
              {data.subtitle_line2}<br />
              {data.subtitle_line3}<br />
              {data.subtitle_line4}
            </p>
          </div>

          {/* Posts carousel - Lower z-index */}
          <div 
            className="relative w-full flex flex-col items-center touch-pan-y"
            onTouchStart={handlePostTouchStart}
            onTouchMove={handlePostTouchMove}
            onTouchEnd={handlePostTouchEnd}
            style={{
              maxWidth: '85vw',
              zIndex: 10
            }}
          >
            <div 
              className="relative w-full" 
              style={{ height: 'auto', overflow: 'visible' }}
            >
              <div className="flex items-center justify-center">
                {visiblePosts.map(({ post, position, key }) => {
                  const baseTranslateX = position * 90;
                  const totalTranslateX = baseTranslateX + (slideOffset / 5.33);
                  const isCenter = position === 0;
                  const isSide = Math.abs(position) === 1;
                  
                  return (
                    <a
                      key={key}
                      href={post.url}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="absolute instagram-post-mobile"
                      style={{
                        maxWidth: '75vw',
                        width: '75vw',
                        left: '50%',
                        transform: `translateX(calc(-50% + ${totalTranslateX}vw))`,
                        opacity: isCenter || isSide ? 1 : 0,
                        transition: 'all 0.4s cubic-bezier(0.4, 0, 0.2, 1)',
                        pointerEvents: isCenter ? 'auto' : 'none',
                        zIndex: isCenter ? 10 : 5 - Math.abs(position)
                      }}
                    >
                      <div 
                        className="instagram-header"
                        style={{
                          padding: '2.5vw 3.5vw'
                        }}
                      >
                        <img 
                          src="https://i.imgur.com/OmUc2Y8.png" 
                          alt="Profile" 
                          className="instagram-avatar"
                          style={{
                            width: '8vw',
                            height: '8vw'
                          }}
                        />
                        <div 
                          className="instagram-username"
                          style={{
                            fontSize: '3.5vw'
                          }}
                        >
                          <span className="font-semibold">bolacha.mulata</span>
                          <span className="instagram-follow">• Seguir</span>
                        </div>
                        <img 
                          src="https://i.imgur.com/Rk0c5ux.png" 
                          alt="Instagram" 
                          className="instagram-icon"
                          style={{
                            width: '6vw',
                            height: '6vw'
                          }}
                        />
                      </div>
                      <div 
                        style={{
                          width: '100%',
                          overflow: 'hidden',
                          background: '#fafafa'
                        }}
                      >
                        <img
                          src={getImageSrc(post.image)}
                          alt={post.alt}
                          style={{
                            width: '100%',
                            height: 'auto',
                            display: 'block'
                          }}
                          onError={(e) => {
                            e.currentTarget.src = `/Imagens/pub${currentPost + 1}.png`;
                          }}
                        />
                      </div>
                    </a>
                  );
                })}
              </div>
            </div>

            <div 
              className="flex justify-center"
              style={{
                gap: '3vw',
                marginTop: '55vw'
              }}
            >
              {posts.map((_, index) => (
                <button
                  key={index}
                  onClick={() => {
                    if (index !== currentPost && !isTransitioning) {
                      if (index > currentPost) {
                        nextSlide();
                      } else {
                        prevSlide();
                      }
                    }
                  }}
                  className="transition-all duration-300"
                >
                  <div
                    style={{
                      width: '3vw',
                      height: '3vw',
                      borderRadius: '50%',
                      backgroundColor: index === currentPost ? '#0099ff' : 'rgb(255, 255, 255)'
                    }}
                  />
                </button>
              ))}
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
